import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { emailReg, passwordReg } from "../../core/Utility";
import {
  getAccessToken,
  setUser,
  removeActiveUser,
} from "../../services/AuthServices";
import logo from "../../assets/logo-login.png";
import logo1 from "../../assets/logo-main-desktop.png";
import "./LoginPage.scss";

const LoginPage = () => {
  const [rememberMe, setRememberMe] = useState<boolean>(
    localStorage.getItem("rememberMe") ? true : false
  );
  const [rememberUser, setRememberUser] = useState<any>({
    email: "",
    password: "",
  });
  const [requiresOtp, setRequiresOtp] = useState<boolean>(false);

  const login = localStorage.getItem("uos-portal-user") ? true : false;
  const navigate = useNavigate();
  const toast = useRef<any>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    values: {
      email: rememberUser.email ?? "",
      password: rememberUser.password ?? "",
      otp: "",
    },
    mode: "onSubmit",
    shouldFocusError: true,
  });

  useEffect(() => {
    try {
      setRememberUser(JSON.parse(localStorage.getItem("rememberMe") || ""));
    } catch (error) {
      // console.log(error)
    }
  }, []);

  useEffect(() => {
    if (login) {
      const savedUserData = JSON.parse(
        localStorage.getItem("uos-portal-user") as string
      );
      if (savedUserData?.tokenExpiration < new Date().getTime()) {
        toast?.current?.show({
          severity: "error",
          detail: `Korisnički token je istekao. Možete se ulogovati ponovo`,
          life: 3000,
        });
        removeActiveUser();
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [login]);

  const handleResetPasswordButton = () => {
    return navigate(`/reset-password/`);
  };

  const handleRegistrationData = (data: {
    email: string;
    password: string;
    otp: string;
  }) => {
    getAccessToken(
      data.email,
      requiresOtp ? data.otp : data.password,
      requiresOtp
    )
      .then((response) => {
        if (response.data.message === "SMS_OTP_SENT") {
          setRequiresOtp(true);
          toast?.current?.show({
            severity: "success",
            detail: `Poslat Vam je kod putem SMS poruke na broj telefona!`,
            life: 3000,
          });
          return;
        }

        const newUser = response.data.result.user;
        if (newUser.status === "Aktivan") {
          setUser({
            id: newUser.id,
            nameAndSurname: newUser.nameAndSurname,
            role: {
              id: newUser.role.id,
              name: newUser.role.name,
            },
            phone: newUser.phone,
            email: newUser.email,
            password: "",
            status: newUser.status,
            accessToken: response.data.result.token,
            tokenExpiration: new Date().getTime() + 13 * 24 * 60 * 60 * 1000, //13 days
          });
          navigate("/dashboard", { replace: true });
        } else {
          toast?.current?.show({
            severity: "error",
            detail: `Korisnički podaci su ispravni, ali korisnik nije u aktivnom statusu`,
            life: 3000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast?.current?.show({
          severity: "error",
          detail: `Neispravni korisnicki podaci`,
          life: 3000,
        });
      });
    if (rememberMe) {
      localStorage.setItem(
        "rememberMe",
        JSON.stringify({ email: data.email, password: data.password })
      );
    } else {
      localStorage.removeItem("rememberMe");
    }
  };

  const handleSendOtpAgain = () => {
    getAccessToken(getValues("email"), getValues("password"), false)
      .then((response) => {
        if (response.data.message === "SMS_OTP_SENT") {
          setRequiresOtp(true);
          toast?.current?.show({
            severity: "success",
            detail: `Poslat Vam je kod putem SMS poruke na broj telefona!`,
            life: 3000,
          });
          return;
        }

        const newUser = response.data.result.user;
        if (newUser.status === "Aktivan") {
          setUser({
            id: newUser.id,
            nameAndSurname: newUser.nameAndSurname,
            role: {
              id: newUser.role.id,
              name: newUser.role.name,
            },
            phone: newUser.phone,
            email: newUser.email,
            password: "",
            status: newUser.status,
            accessToken: response.data.result.token,
            tokenExpiration: new Date().getTime() + 13 * 24 * 60 * 60 * 1000, //13 days
          });
          navigate("/dashboard", { replace: true });
        } else {
          toast?.current?.show({
            severity: "error",
            detail: `Korisnički podaci su ispravni, ali korisnik nije u aktivnom statusu`,
            life: 3000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast?.current?.show({
          severity: "error",
          detail: `Neispravni korisnicki podaci`,
          life: 3000,
        });
      });
    if (rememberMe) {
      localStorage.setItem(
        "rememberMe",
        JSON.stringify({
          email: getValues("email"),
          password: getValues("password"),
        })
      );
    } else {
      localStorage.removeItem("rememberMe");
    }
  };

  const isValidEmail = (email: string) => emailReg.test(email);

  const handleEmailValidation = (email: string) => {
    const isValid = isValidEmail(email);
    return isValid;
  };

  const isValidPassword = (password: string) => passwordReg.test(password);

  const handlePasswordValidation = (password: string) => {
    const isValid = isValidPassword(password);
    return isValid;
  };

  const handleRememberMe = () => {
    return setRememberMe(!rememberMe);
  };

  return (
    <>
      <div className="message">
        <p className="message-text">
          Nije podržano za uredjaje manjih dimenzija .
        </p>
      </div>
      <div className="login-page">
        <Toast ref={toast} position={"top-right"} />
        <form
          onSubmit={handleSubmit(handleRegistrationData)}
          className="login-form"
        >
          <div className="inner-box">
            {requiresOtp ? (
              <>
                <div className="first-row">
                  <div className="login-image">
                    <img src={logo1} alt="logo" className="image" />
                  </div>
                  <div className="wrapper">
                    <label className="label">Autorizacioni kod</label>
                    <input
                      className={errors.otp ? "input-error" : "input"}
                      {...register("otp", {
                        required: true,
                        // validate: handlePasswordValidation
                      })}
                      minLength={6}
                      maxLength={6}
                      type="text"
                      placeholder={"Unesite autorizacioni kod"}
                    />
                    {/* {errors.password && (
                          <p className="message">
                              1 veliko slovo, 1 malo slovo, 1 broj; minimalno 8 karaktera
                          </p>
                      )} */}
                  </div>
                </div>
                <div className="second-row">
                  <div className="forgot-password" onClick={handleSendOtpAgain}>
                    <p>Pošaljite ponovo kod</p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="first-row">
                  <div className="login-image">
                    <img src={logo1} alt="logo" className="image" />
                  </div>
                  <div className="wrapper">
                    <label className="label">Email</label>
                    <input
                      className={errors.email ? "input-error" : "input"}
                      {...register("email", {
                        required: true,
                        validate: handleEmailValidation,
                      })}
                      placeholder={"Unesite email"}
                    />
                    {errors.email && (
                      <p className="message">Email format nije ispravan.</p>
                    )}
                  </div>
                  <div className="wrapper">
                    <label className="label">Šifra</label>
                    <input
                      className={errors.password ? "input-error" : "input"}
                      {...register("password", {
                        required: true,
                        // validate: handlePasswordValidation
                      })}
                      type="password"
                      placeholder={"Unesite šifru"}
                    />
                    {/* {errors.password && (
                              <p className="message">
                                  1 veliko slovo, 1 malo slovo, 1 broj; minimalno 8 karaktera
                              </p>
                          )} */}
                  </div>
                </div>
                <div className="second-row">
                  <div className="remember-me">
                    <Checkbox
                      checked={rememberMe}
                      onChange={handleRememberMe}
                      className="checkbox-field"
                    />
                    <label>Zapamti me</label>
                  </div>
                  {/* <div
                    className="forgot-password"
                    onClick={handleResetPasswordButton}
                  >
                    <p>Zaboravili ste šifru?</p>
                  </div> */}
                </div>
              </>
            )}

            <hr className="line"></hr>
            <input
              style={{ display: "none" }}
              id="register-btn"
              type="submit"
            />
            <label className="button" htmlFor="register-btn">
              LOG IN
            </label>
          </div>
        </form>
        <div className="uos-portal-image">
          <img src={logo} alt="logo" className="image" />
        </div>
      </div>
    </>
  );
};

export default LoginPage;
